import React from 'react';
import { MyFocusAreaDefinition } from 'libs/end-to-end/src/my-focus-area-definition';
import { MyObservation } from 'libs/end-to-end/src/my-observation';
import { CustomViz } from 'apps/sigma2-ui/src/components/custom-viz/CustomViz';
import { BiasAnalysisCustomVizDefinition } from 'libs/end-to-end/src/custom-viz/BiasAnalysisDefinition';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import { FocusAreaNewDataIntelligenceSummaryInterface } from 'apps/sigma2-ui/src/focus-area/FocusAreaNewDataIntelligenceSummaryInterface';
import { EntitledDetailsForFocusAreaPage } from 'libs/end-to-end/src/focus-area-utils';

export const FocusAreaNewDataIntelligenceSummaryView = ({
  focusAreaDefinition,
  observation,
  organizationId,
  entitledDetailsForFocusAreaPage,
}: {
  focusAreaDefinition: MyFocusAreaDefinition;
  observation: MyObservation;
  organizationId: string;
  entitledDetailsForFocusAreaPage: EntitledDetailsForFocusAreaPage;
}) => {
  const { userAuthenticatedApiCall } = useUser();

  return (
    <CustomViz
      observation={observation.type}
      organizationId={organizationId}
      customVizDefinition={BiasAnalysisCustomVizDefinition}
      userAuthenticatedApiCall={userAuthenticatedApiCall}
    >
      <FocusAreaNewDataIntelligenceSummaryInterface
        focusAreaDefinition={focusAreaDefinition}
        observation={observation}
        organizationId={organizationId}
        entitledDetailsForFocusAreaPage={entitledDetailsForFocusAreaPage}
      />
    </CustomViz>
  );
};
